<template>
  <header>
    <div class="header">
      <!--Logo-->
      <div class="header-left">
        <!-- <a href="javascript:void(0)" @click.prevent class="logo">
          <img src="../../assets/logo_huper.png" width="80%" alt="" />
        </a> -->
      </div>
      <!-- Toggle button -->
      <a id="toggle_btn" href="javascript:void(0);">
        <span class="bar-icon">
          <span></span>
          <span></span>
          <span></span>
        </span>
      </a>
      <!-- Header Title -->
      <a id="mobile_btn" class="mobile_btn" href="#sidebar">
        <i class="fa fa-bars"></i>
      </a>
      <!-- User Account Menu -->
      <ul class="nav user-menu" v-if="tokenObj">
        <li class="nav-item dropdown has-arrow main-drop">
          <a href="#" class="dropdown-toggle nav-link" data-toggle="dropdown">
            <span class="user-img">
              <img src="../../assets/profiles/user4.jpg" alt="" />
            </span>
            <span>{{ tokenObj ? tokenObj.name : null }}</span>
          </a>
          <div class="dropdown-menu">
            <router-link
              :to="{
                name:
                  tokenObj.role == 'admin'
                    ? 'adminChangePassword'
                    : 'merchantChangePassword',
              }"
              class="dropdown-item"
            >
              Change Password
            </router-link>
            <a class="dropdown-item" href="#" @click.prevent="logout">Logout</a>
          </div>
        </li>
      </ul>
      <!-- Mobile User Account Menu -->
      <div class="dropdown mobile-user-menu" v-if="tokenObj">
        <a
          href="#"
          class="nav-link dropdown-toggle"
          data-toggle="dropdown"
          aria-expanded="false"
        >
          <i class="fa fa-ellipsis-v"> </i>
        </a>
        <div class="dropdown-menu dropdown-menu-right">
          <a
            class="dropdown-item"
            href="#"
            @click.prevent="$router.push({ name: 'passwordChange' })"
          >
            Change Password
          </a>
          <a class="dropdown-item" href="#" @click.prevent="logout">Logout</a>
        </div>
      </div>
    </div>
  </header>
</template>
  
<script>
import config from "../../config.js";
import API from "../../http-common.js";
export default {
  data() {
    return {
      userRoleSuperAdmin: config.USER_ROLE_SUPER_ADMIN,
      userRoleAdmin: config.USER_ROLE_ADMIN,
      userRoleMerchantAdmin: config.USER_ROLE_MERCHANT_ADMIN,
      userRoleMerchantUser: config.USER_ROLE_MERCHANT_USER,
    };
  },
  computed: {
    tokenObj() {
      let data = JSON.parse(localStorage.getItem("emstoken"));
      return data;
    },
  },
  methods: {
    logout() {
      API.logout(
        {},
        { headers: { Authorization: `Bearer ${this.tokenObj.token}` } }
      )
        .then((response) => {
          if (response.data.success) {
            localStorage.removeItem("emstoken");
            if (
              this.tokenObj.role == this.userRoleSuperAdmin ||
              this.tokenObj.role == this.userRoleAdmin
            )
              window.location = "/admin/login";
            else if (
              this.tokenObj.role == this.userRoleMerchantAdmin ||
              this.tokenObj.role == this.userRoleMerchantUser
            )
              window.location =
                "/merchant/login/" + this.tokenObj.merchant_code;
          } else {
            this.$swal(response.data.message, { icon: "error" });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mounted() {
    // Variables declarations
    var $wrapper = $(".main-wrapper");

    $("body").append('<div class="sidebar-overlay"></div>');
    $(document).on("click", "#mobile_btn", function () {
      $wrapper.toggleClass("slide-nav");
      $(".sidebar-overlay").toggleClass("opened");
      $("html").addClass("menu-opened");
      $("#task_window").removeClass("opened");
      return false;
    });
    $(".sidebar-overlay").on("click", function () {
      $("html").removeClass("menu-opened");
      $(this).removeClass("opened");
      $wrapper.removeClass("slide-nav");
      $(".sidebar-overlay").removeClass("opened");
      $("#task_window").removeClass("opened");
    });

    $(document).on("click", ".top-nav-search .responsive-search", function () {
      $(".top-nav-search").toggleClass("active");
    });

    $(".sidebar-menu ul li:not(.submenu) a").click(function () {
      $("html").removeClass("menu-opened");
      $(".sidebar-overlay").removeClass("opened");
    });
  },
};
</script>
  
  <style scoped>
.header .header-left {
  width: 245px;
}
.dropdown-menu.show {
  margin-top: 0;
}

@media only screen and (min-width: 991px) {
  .mini-sidebar .header .header-left {
    width: 60px;
  }
  /* .mini-sidebar .header-left .logo img {
      content: url("../../assets/logo_huper.png");
      width: 35px;
    } */
}

@media only screen and (max-width: 991.98px) {
  .header .header-left {
    width: 100%;
  }
}
</style>
  


// WEBPACK FOOTER //
// src/components/Layout/Header.vue